import { useState } from "react";
import Input from "../custom-control/Input";
import Select from "../custom-control/Select";
import Accordion from "../custom-control/Accordion";
import styles from "./MyForm.module.scss";
import { isEmail } from "../util/validator";
import { GENDER_LIST, ROLE_LIST,VISA_STATUS_LIST,LICENSE_STATUS_LIST,JOB_TITLE_LIST } from "../util/constants";
import { insertAgent } from "../http";
import { useNavigate } from "react-router-dom";
import GoogleAddressInput from "../custom-control/GoogleAddressInput";
import header from "./header.jpg";
import footer from "./footer.jpg";
import MobileInput from "../custom-control/MobileInput";

//import axios from "axios";

export default function MyForm() {
  const [isLoading, setIsLoading] = useState(false);
  const [loadingText, setLoadingText] = useState("");
  const [serverErrors, setServerErrors] = useState("");
  const [companyEmailIsInvalid, setCompanyEmailIsInvalid] = useState(false);
  const [personalEmailIsInvalid, setPersonalEmailIsInvalid] = useState(false);
  const [fields, setFields] = useState({});
  const [errors, setErrors] = useState([]);
  const navigate = useNavigate();

  // const changeHandler(field,value)=>{
  //   setErrors({
  //     ...errors,
  //     [field]:value?
  //   })
  // }
  function sumbitHandler(event) {
    event.preventDefault();
    const fd = new FormData(event.target);
    const formData = Object.fromEntries(fd.entries());
    console.log(formData);
    const formErrors = [];
    let formIsValid = true;
    //validate the input here
    if (!formData["firstName"]) {
      formErrors["firstName"] = "First name required";

      formIsValid = false;
    }
    if (!formData["lastName"]) {
      formErrors["lastName"] = "Last name required";
      formIsValid = false;
    }

    if (!formData["addressLine1"]) {
      formErrors["addressLine1"] = "Street address is required";
      formIsValid = false;
    }
    if (!formData["suburb"]) {
      formErrors["suburb"] = "Suburb is required";
      formIsValid = false;
    }
    if (!formData["state"]) {
      formErrors["state"] = "State is required";
      formIsValid = false;
    }
    if (!formData["postcode"]) {
      formErrors["postcode"] = "Postcode is required";
      formIsValid = false;
    }

    setErrors(formErrors);

    if (formIsValid) {
      setIsLoading(true);
      setLoadingText("saving data, please wait...");
      insertAgent(formData)
        .then((response) => {
          navigate("completion");
        })
        .catch((error) => {})
        .finally(() => {
          setIsLoading(false);
        });
    }
  }
  function clearErrorHandler(id) {
    setErrors((prev) => {
      let errs = { ...prev };
      errs[id] = "";
      return errs;
    });
  }
  function setErrorHandler(id) {
    setErrors((prev) => {
      let errs = { ...prev };
      errs[id] = `${id} required`;
      return errs;
    });
  }
  function handleOnBlur(event) {
    console.log(event.target.value);
    const node = event.target;
    if (node.name === "companyEmail") {
      setCompanyEmailIsInvalid(!isEmail(node.value));
    }
    if (node.name === "personalEmail") {
      setPersonalEmailIsInvalid(!isEmail(node.value));
    }
  }

  return (
    <>
      <div className={styles.page}>
        <img src={header} alt="logo" className={styles.headerImage} />
        <form
          id="form"
          name="form"
          className={styles.form}
          onSubmit={sumbitHandler}
        >
          <Accordion label="Personal Info">
            <Input
              name="firstName"
              id="firstName"
              label="First Name"
              mandatory="true"
              error={errors["firstName"] ? "First name is required" : ""}
            />
              <Input
              name="middleName"
              id="middleName"
              label="Middle Name"
              type="text"
            />
            <Input
              name="lastName"
              id="lastName"
              label="Last Name"
              type="text"
              mandatory="true"
              error={errors["lastName"] ? "Last name is required" : ""}
            />
              <Input
              name="preferredName"
              id="preferredName"
              label="Preferred Name"
              type="text"
            />
             <Input type="date" name="dob" id="dob" label="Date Of Birth" />
            <Input
              name="companyEmail"
              id="companyEmail"
              label="Company Email"
              type="email"
              mandatory="true"
              onBlur={handleOnBlur}
              error={companyEmailIsInvalid ? "Invalid email address" : ""}
            />
            <Input
              name="personalEmail"
              id="personalEmail"
              label="Personal Email"
              type="email"
              mandatory="true"
              onBlur={handleOnBlur}
              error={personalEmailIsInvalid ? "Invalid email address" : ""}
            />
            <MobileInput name="Mobile" id="Mobile" type="text" label="Mobile"/>
            <GoogleAddressInput
              label="Street Address"
              clearError={clearErrorHandler}
              setError={setErrorHandler}
              errors={errors}
            ></GoogleAddressInput>
                <Select
              name="visaStatus"
              id="visaStatus"
              label="Status"
              simpleValues={VISA_STATUS_LIST}
            ></Select>
            <Input
              name="emergencyContact"
              id="emergencyContact"
              label="Emergency Contact"
              type="text"
            />
               <Input
              name="contactNumber"
              id="contactNumber"
              label="Contact Number"
              type="text"
            />
        
          </Accordion>
          <Accordion label="License & A/C">
          <Select
              name="jobTitle"
              id="jobTitle"
              label="Position"
              simpleValues={JOB_TITLE_LIST}
            ></Select>
             <Select
              name="licenseStatus"
              id="licenseStatus"
              label="License Status"
              simpleValues={LICENSE_STATUS_LIST}
            ></Select>
            <Input
              name="licenseNumber"
              id="licenseNumber"
              type="text"
              label="Certificate /License Number"
            />
             <Input name="tfn" id="tfn" type="text" label="TFN" />
             <Input name="superCompany" id="superCompany" type="text" label="Super Company" />
             <Input name="superCompanyAbn" id="superCompanyAbn" type="text" label="Super Company ABN" />
             <Input name="superUsi" id="superUsi" type="text" label="Super USI" />
             <Input name="superAccountNo" id="superAccountNo" type="text" label="Super A/C No" />
           
             <Input
              name="accountName"
              id="accountName"
              type="text"
              label="Bank A/C Name"
            />
            <Input name="bsb" id="bsb" type="text" label="BSB" />
            <Input
              name="accountNo"
              id="accountNo"
              type="text"
              label="A/C No"
            />
            <span className={styles.footNote}>
            I acknowledge that I am responsible to check and satisfy the related license & insurance regulation & requirements from the industry with ongoing basis.
            </span>
            {/* <Select
              name="role"
              id="role"
              label="Role"
              values={ROLE_LIST}
            ></Select> */}
          </Accordion>


           

          <Accordion label="Social Media">
            <Input name="linkedIn" id="linkedIn" type="text" label="LinkedIn" />

            <Input name="faceBook" id="faceBook" type="text" label="FaceBook" />

            <Input name="youtube" id="youtube" type="text" label="Youtube" />

            <Input name="wechat" id="wechat" type="text" label="Wechat" />
          </Accordion>


          
         
          <div className={styles.submitWrapper}>
            <button className={styles.submit}>SUBMIT</button>
          </div>
        </form>
        <img src={footer} alt="logo" className={styles.headerImage} />
      </div>
    </>
  );
}
